import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Router, UrlTree } from '@angular/router';
import { ErrorCode } from '@core/components/error/error.component';

@Injectable({
  providedIn: 'root'
})
export class SupportedPlatformGuard implements CanActivateChild, CanActivate, CanLoad {
  constructor(private $router: Router) {}

  public canActivateChild(): boolean | UrlTree {
    return this.fromNotSupportedPlatform() ? this.$router.createUrlTree(['/error/', this.getErrorCode()]) : true;
  }

  public canLoad(): boolean | Promise<boolean> {
    return this.fromNotSupportedPlatform() ? this.$router.navigate(['/error/', this.getErrorCode()]) : true;
  }

  public canActivate(): boolean | UrlTree {
    return this.fromNotSupportedPlatform() ? this.$router.createUrlTree(['/error/', this.getErrorCode()]) : true;
  }

  private isMobile() {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some(toMatchItem => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  private isIE(): boolean {
    return navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
  }

  private fromNotSupportedPlatform(): boolean {
    return this.isIE();
  }

  private getErrorCode(): ErrorCode {
    if (this.isMobile()) {
      return ErrorCode.Mobile;
    }

    if (this.isIE()) {
      return ErrorCode.IE;
    }
  }
}
